import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ListTodo, ArrowRight } from 'lucide-react';
import { TaskRow } from './TaskRow';
import { useTasks } from './useTasks';
import { taskBucket } from '@/lib/taskUtils';

export function TasksDueWidget() {
  const navigate = useNavigate();
  const { tasks, toggle, remove, snooze } = useTasks({ status: 'open' });
  const overdue = tasks.filter(t => taskBucket(t) === 'overdue');
  const today = tasks.filter(t => taskBucket(t) === 'today');
  const shown = [...overdue, ...today].slice(0, 6);

  return (
    <Card className="bg-white border-gray-200 shadow-sm" data-testid="tasks-due-widget">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center justify-between">
          <p className="text-base font-semibold text-gray-900 flex items-center gap-2"><ListTodo className="h-4 w-4 text-[#0073ea]" /> Due Today / Overdue</p>
          <div className="flex items-center gap-3 text-xs">
            <span data-testid="widget-overdue-count" className={overdue.length ? 'text-red-600 font-semibold' : 'text-gray-400'}>{overdue.length} overdue</span>
            <span data-testid="widget-today-count" className="text-[#0073ea] font-medium">{today.length} today</span>
            <button data-testid="widget-view-all" onClick={() => navigate('/tasks')} className="text-gray-500 hover:text-gray-900 flex items-center gap-1">View all <ArrowRight className="h-3 w-3" /></button>
          </div>
        </div>
        {shown.length === 0 ? <p className="text-sm text-gray-400 text-center py-3">You're all caught up</p> : (
          <div className="space-y-1.5">{shown.map(t => <TaskRow key={t.id} task={t} onToggle={toggle} onEdit={() => navigate('/tasks')} onDelete={remove} onSnooze={snooze} />)}</div>
        )}
      </CardContent>
    </Card>
  );
}
